// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AAh7w","fullView":"styles_fullView__3hwrs"};